import React from "react";
import PropTypes from "prop-types";
import "../Time.scss";

export default function Time({ startdate, starttime, enddate, endtime }) {
  const startDate = new Date(startdate).toLocaleDateString("sv", {
    day: "numeric",
    month: "short"
  });
  const endDate = new Date(enddate).toLocaleDateString("sv", {
    day: "numeric",
    month: "short"
  });

  const startTime = new Date("2025-12-12 " + starttime).toLocaleString("sv", {
    hour: "numeric",
    minute: "numeric",
    hour12: false
  });
  const endTime = new Date("2025-12-12 " + endtime).toLocaleString("sv", {
    hour: "numeric",
    minute: "numeric",
    hour12: false
  });

  return (
    <div className="time">
      {startDate} kl {startTime} - {endDate != startDate ? endDate : ""} kl{" "}
      {endTime}
    </div>
  );
}

Time.propTypes = {
  startdate: PropTypes.string.isRequired,
  starttime: PropTypes.string.isRequired,
  enddate: PropTypes.string.isRequired,
  endtime: PropTypes.string.isRequired
};
